module.exports = __webpack_public_path__ + "static/images/photoAlbum/download-active.svg";